import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {Form} from 'react-bootstrap'
import ReactFlow, {useNodesState, useEdgesState, addEdge, MiniMap, Controls} from 'reactflow'
import 'reactflow/dist/style.css'
import TimeDelayPopup from './model/TimeDelayPopup'
import TriggerActionPopup from './model/TriggerActionPopup'
import SendMessagePopup from './model/SendMessagePopup'
import ConditionalSplitPopup from './model/ConditionalSplitPopup'

const AutomationFlow = ({initialNodes, initialEdges, nodeTypes}: any) => {
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes as any)
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges)
  const [nodeData, setNodeData] = useState<any>({})
  const [timeDelay, setTimeDelay] = useState(false)
  const [sendMessage, setSendMessage] = useState(false)
  const [conditionalSplit, setConditionalSplit] = useState(false)
  const [triggerAction, setTriggerAction] = useState(false)
  const [isUpdate, setIsUpdate] = useState(false)

  const onNodeClick = (e: any) => {
    const node =
      initialNodes?.find((node: any) => node?.id == e?.find((data: any) => data?.selected)?.id) ??
      {}
    setNodeData(node)
    if (!!node?.type) setIsUpdate(true)
  }

  const handleUpdate = () => {
    if (nodeData?.type == 'trigger') {
      setTriggerAction(true)
    }
    if (nodeData?.type == 'timeDelay') {
      setTimeDelay(true)
    }
    if (nodeData?.type == 'sendMessage') {
      setSendMessage(true)
    }
    if (nodeData?.type == 'conditionalSplit') {
      setConditionalSplit(true)
    }
  }

  const TriggerActionModel = useMemo(
    () => <TriggerActionPopup show={triggerAction} handleClose={() => setTriggerAction(false)} />,
    [triggerAction]
  )
  const SendMessageModel = useMemo(
    () => <SendMessagePopup show={sendMessage} handleClose={() => setSendMessage(false)} />,
    [sendMessage]
  )
  const TimeDelayModel = useMemo(
    () => <TimeDelayPopup show={timeDelay} handleClose={() => setTimeDelay(false)} />,
    [timeDelay]
  )
  const ConditionalSplitModel = useMemo(
    () => (
      <ConditionalSplitPopup
        show={conditionalSplit}
        handleClose={() => setConditionalSplit(false)}
      />
    ),
    [conditionalSplit]
  )

  return (
    <>
      {TriggerActionModel}
      {SendMessageModel}
      {TimeDelayModel}
      {ConditionalSplitModel}
      <ReactFlow
        nodes={nodes}
        edges={edges}
        // onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        nodeTypes={nodeTypes}
        onNodesChange={(e) => onNodeClick(e)}
        fitView
        className='react-flow-node'
        fitViewOptions={{
          nodes: [{id: '1'}, {id: '2'}, {id: '3'}, {id: '4'}],
        }}
        attributionPosition='top-center'
      >
        <div className='flow-container'>
          <img src='/media/svg/automation/element-plus.svg' alt='icon' />
          <button disabled={!isUpdate}>
            <div
              className={`flow-button ${!isUpdate ? 'disable-button' : ''}`}
              onClick={() => handleUpdate()}
            >
              <img src='/media/svg/automation/save-2.svg' alt='icon' />
              Update
            </div>
          </button>
          <Form.Check
            // onChange={(e) => setToggleHeader(!toggleHeader)}
            // checked={toggleHeader}
            className='flow-switch'
            type='switch'
            id='custom-switch'
          />
        </div>
        <Controls />
      </ReactFlow>
    </>
  )
}

export default AutomationFlow
